export default __webpack_public_path__ + "static/media/cheese.1aa54fee.png";